import moment from 'moment-timezone';
import { SET_LOGBOOK_FILTER, SET_LOGBOOK_SELECTOR } from '../actions/constants';
import Periods from '../utils/DatePickerNavBarStrings';

const defaultState = {
  selectedStartDate: null,
  selectedEndDate: null,
  selectedPeriod: null,

  // For debugging purposes:
  // selectedStartDate: '2024-04-06T12:07:00.000Z',
  // selectedEndDate: '2024-04-08T12:06:00.000Z',
  // selectedPeriod: 'hour',

  filterStartDate: null,
  filterEndDate: null,
  filterPeriod: null,

  filterStartIndex: 0,
  filterEndIndex: 0,
};

const logbooksRowLimit = 2880;
// Optional feature: logbook aggregation
// <= 2 days == max 2880 rows == 1 minute
// (optional aggregation) <= 6 days == max 2880 rows == 3 minute
// (optional aggregation) <= 14 days == max 2880 rows == 7 minutes
// <= 120 dagen == max 2880 rows == hours
// <= 365 dagen == max 365 rows == days
// > 365 dagen == error -> months

const resolution = (startDate, endDate) => {
  const m_startDate = moment(startDate);
  const m_endDate = moment(endDate);

  if (m_endDate.diff(m_startDate, 'minutes') <= logbooksRowLimit)
    return Periods.MINUTE;
  if (m_endDate.diff(m_startDate, 'hours') <= logbooksRowLimit)
    return Periods.HOUR;
  if (m_endDate.diff(m_startDate, 'days') <= logbooksRowLimit)
    return Periods.DAY;

  return Periods.MONTH;
};

export const LogbookSelectorReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_LOGBOOK_SELECTOR: {
      const { selectedStartDate, selectedEndDate } = action;
      const selectedPeriod = resolution(selectedStartDate, selectedEndDate);
      return {
        ...state,
        selectedStartDate,
        selectedEndDate,
        selectedPeriod,
      };
    }
    case SET_LOGBOOK_FILTER: {
      const {
        filterStartDate,
        filterEndDate,
        filterStartIndex,
        filterEndIndex,
      } = action;
      const filterPeriod = resolution(filterStartDate, filterEndDate);
      return {
        ...state,
        filterStartDate,
        filterEndDate,
        filterStartIndex,
        filterEndIndex,
        filterPeriod,
      };
    }
    default:
      return state;
  }
};
